<template>
  <div class="event-results">
    <v-container class="fixed-container">

    <div v-for="(event, index) in sortedEvents" :key="event.id || index" outlined>
      <v-card
        class="event-card"
        :class="{ 
        selected: selectedEvent && (
          (selectedEvent.date && selectedEvent.date === event.date) ||
          (!selectedEvent.date && selectedEvent.start_date === event.start_date)
        )
        }"
        @click="selectEvent(event)"
      >
        <v-card-title class="event-header">
          <span v-if="eventDuration !== 'hours'" class="event-date">
            {{ formatDate(event.start_date) }} - {{ formatDate(event.end_date) }}
          </span>
          <span v-else class="event-date">
            {{ formatDate(event.date) }}
          </span>

          <p style="display: flex; margin: 0;">
            <span class="event-participants">
              {{ event.votes?.reduce((acc, current) => acc + current, 0) }} /
            </span>
            <span class="event-participants d-none d-md-block">
              {{ event.total_participants || 0 }} participantes
            </span>
            <span
              class="event-participants d-md-none d-block"
              :style="{ paddingRight: '15px', fontSize: '14px' }"
            >
              {{ event.total_participants || 0 }}
              <v-icon>mdi-account</v-icon>
            </span>
          </p>
        </v-card-title>

        <v-card-text>
          <div class="event-status">
            <span v-if="eventDuration === 'hours'" class="event-time">
              {{ formatEventTime(event.start_time, event.end_time) }}
            </span>

            <span
              class="status-dot not-voted"
              @click="toggleParticipants(event.participants[0]); showParticipants(event.participants[0])"
            >
              {{ event.votes[0] }}
            </span>
            <span
              class="status-dot not"
              @click="toggleParticipants(event.participants[1]); showParticipants(event.participants[1])"
            >
              {{ event.votes[1] }}
            </span>
            <span
              class="status-dot maybe"
              @click="toggleParticipants(event.participants[2]); showParticipants(event.participants[2])"
            >
              {{ event.votes[2] }}
            </span>
            <span
              class="status-dot yes"
              @click="toggleParticipants(event.participants[3]); showParticipants(event.participants[3])"
            >
              {{ event.votes[3] }}
            </span>
          </div>
        </v-card-text>
      </v-card>
    </div>


    <div v-if="sortedEvents.length === 0" class="no-results">Não há resultados ainda...</div>

    <div v-if="selectedEvent" class="div-close-date-btn">
      <v-btn color="white"  @click="closeEvent" class="close-date-btn mt-4">
        Fechar data
      </v-btn>
    </div>
    
  </v-container>

    <!-- Modal de participantes -->
    <v-dialog v-model="showModal" max-width="400px">
      <v-card class="show-participants-modal">
        <v-card-title class="modal-title">
          <span>Participantes</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="showModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p v-if="hoveredParticipants.length === 0">Nenhum participante</p>
          <ul v-else>
            <li v-for="user in hoveredParticipants" :key="user.email">
              <strong>{{ user.name }}</strong> ({{ user.email }})
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
import Events from '@/api/Events.js';

export default {
  name: 'EventResults',
  props: {
    eventId: {
      type: String,
      required: true
    },
    eventDuration: {
      type: String,
      required: true
    },
    eventDates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      events: [],
      selectedEvent: null,
      hoveredParticipants: [],
      showModal: false,
      isMobile: false,
      sortedEventsReady: false
    };
  },

  watch: {
    selected(newVal) {
      if (newVal === 'calendar') {
        this.eventDatesKey++; // 🔄 Garante que o componente de datas é recriado
        this.$nextTick(() => {
          this.updateSelectedColors(); // 🔥 Atualiza as cores do calendário
        });
      }
    },
    sortedEvents(newValue) {
    if (newValue.length > 0) {
      this.sortedEventsReady = true
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    }
  }
  },

  computed: {
  sortedEvents() {
    console.log(this.events)
    return [...this.events];
  }
},
  methods: {

     isSortedEventsReady() {
    return this.sortedEvents.length > 0
  },
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
    },

    showParticipants(participants) {
      if (!this.isMobile && participants.length > 0) {
        this.hoveredParticipants = participants;
        this.showModal = true;
      }
    },

    hideParticipants() {
      if (!this.isMobile) {
        this.hoveredParticipants = [];
        this.showModal = false;
      }
    },

    toggleParticipants(participants) {
      if (this.isMobile) {
        this.hoveredParticipants = participants;
        this.showModal = true;
      }
    },

    async fetchResults() {
      try {
        const response = await Events.getResults(this.eventId);
        
        this.events = response.data.map((event, index) => ({
          id: index + 1,
          ...event
        }));
      } catch (error) {
        console.error("Erro ao buscar resultados:", error);
      }
    },
    
    selectEvent(event) {
      this.selectedEvent = this.selectedEvent && this.selectedEvent.date === event.date ? null : event;
      console.log("Evento selecionado:", this.selectedEvent, event);
    },

    async closeEvent() {
      if (!this.selectedEvent) return;

      const payload = {
        event_id: this.eventId,
        duration: this.eventDuration,
        date: this.selectedEvent.date,
        start_time: this.eventDuration == 'hours' ? this.selectedEvent.date + ' ' + this.selectedEvent.start_time : this.selectedEvent.start_date.split(" - ")[0],
        end_time: this.eventDuration == 'hours' ? this.selectedEvent.date + ' ' + this.selectedEvent.end_time : this.selectedEvent.end_date.split(" - ")[0],
        total_participants: this.selectedEvent.total_participants,
        votes: this.selectedEvent.votes ? { ...this.selectedEvent.votes } : {}
      };


      try {
        await Events.closeEvent(payload);
        
        this.selectedEvent = null;

        this.$router.push({ name: 'Events' });

      } catch (error) {
        console.error("Erro ao fechar evento:", error);
        alert("Erro ao fechar evento.");
      }
    },

    formatEventTime(startTime, endTime) {
      const format = time => time.slice(0, 5);
      return `${format(startTime)} - ${format(endTime)}`;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}`;
      return formattedDate;
    }
  },
  created() {
    this.fetchResults();
  }
};
</script>

<style scoped>

  .event-results {
    overflow: auto !important;
  }

.event-card {
  width: 100%;
  max-width: none;
  border: 1px solid #ccc;
  border-radius: 50px;
  padding: 16px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #ffffff93;
  padding-top: 0;
  margin-top: 0;
  margin-bottom: 10px;
}

.event-card:first-child {
  margin-top: 0 !important;
}

.event-card:last-child {
  margin-bottom: 70px !important;
}

.event-card.selected {
  background-color: #ffffff;
  color: white;
  
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.2);
}

.event-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: black;
  border-bottom: none;
  padding-bottom: 8px;
  margin-bottom: 10px;
}

.event-date {
  text-align: left;
  flex: 1;
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
  margin-right: 10px;
}

.event-time {
  text-align: center;
  flex: 1;
  font-size: 12px;
  font-weight: normal;
}

.event-participants {
  text-align: right;
  flex: 1;
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  margin-left: 8px;
}

.event-status {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.status-dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #000;
  font-weight: bold;
}

.status-dot.not-voted {
  background-color: #fff;
  color: #000;
  border: 1px solid #ccc;
}

.status-dot.not {
  background-color: #fa9a9a;
  color: #000;
}

.status-dot.maybe {
  background-color: #f5e720;
  color: #000;

}

.status-dot.yes {
  background-color: #cbd8c7;
  color: #000;
}

.status-dot:hover {
  opacity: 0.6 !important;
}

.close-date-btn {
  margin-bottom: 10px;
  color: black;
  display: flex;
  justify-content: center;
  border-radius: 50px;
  width: 70%;
  text-transform: none;
  box-shadow: none;
}

.div-close-date-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 108%;
  position: sticky;
  height: 60px;
  bottom: 0px;
  margin-bottom: -20px;
  margin-left: -20px;
  padding-inline: 30px;
  background:  #E9CFED;
}

.show-participants-modal {
  background-color: #ffffffcc;
  border-radius: 25px;
}

.theme--light.v-card {
  color: rgba(0, 0, 0, 0);
}

  ::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
  }

  ::-webkit-scrollbar {
    width: 8px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #b0b0b0;
    border-radius: 10px;
  }

@media (max-width: 768px) {
  .event-card {
    width: 100%;
    max-width: 400px;
    font-size: 14px;
  }

  .event-date {
    font-size: 15px;
  }

  .event-header {
    font-size: 16px;
    flex-direction: row;
    align-items: center;
    text-align: center;
  }

  .event-status {
    flex-wrap: wrap;
  }

  .status-dot {
    width: 30px;
    height: 30px;
    font-size: 12px;
  }

  .event-results {
    width: 100%;
  }

  .fixed-container {
    width: 90vw;
    margin-bottom: 2rem;
  }

  .div-close-date-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    margin-bottom: 30px;
    padding-top: 1rem;
    height: auto;
    background: linear-gradient(to top, rgba(233, 207, 237, 1), rgba(233, 207, 237, 1) 90%, rgba(233, 207, 237, 0.2) 90%, transparent 10%);
  }

  .close-date-btn {
    margin-bottom: 70px;
  }

  .no-results {
    margin-left: 20px; 
    font-size: 14px;
    margin-top: 1rem;
  }
}
</style>
